import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject, signal } from '@angular/core';
import { Departaments } from 'app/core/models/departaments.model';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OABCookieService } from 'app/core/services/oab-cookie.service';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie';
import { set } from 'lodash';

@Component({
    selector: 'oab-setores-modal-v2',
    templateUrl: './oab-setores-modal.component.html',
    styleUrls: ["./oab-setores-modal.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ReactiveFormsModule],
})
export class OabSetoresModalV2Component implements OnInit, OnDestroy{
 private formBuilder = inject(FormBuilder);
 private oabCookieService = inject(OABCookieService);
 private cookieService = inject(CookieService);


 @Input() 
 showModal = false;

 @Output() handleModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  organizacoes = signal<Departaments[]>([]);
  selecaoForm: FormGroup;
  subscptions: Subscription[] = new Array<Subscription>();
  setoresPorOrg = signal<any[]>([]);

  ngOnInit() {
    this.organizacoes.set(this.oabCookieService.getUsersPermissions());
    this.selecaoForm = this.formBuilder.group({
      organizacao: ["", [Validators.required]],
      setor: [{ value: "", disabled: true }, [Validators.required]],
    });
  }

  ngOnDestroy() {
    this.subscptions.forEach((item) => item.unsubscribe());
  }

  closeModal() {
    this.handleModal.emit(false);
  }
  compareSetrDropDown(setor1: any, setor2: any): boolean {
    return setor1 && setor2
      ? setor1.codiSetr === setor2.codiSetr
      : setor1 === setor2;
  }
  changeOrganizacao = (value) => {
    this.selecaoForm.controls.setor.enable();

    const setores = this.organizacoes().filter(
      (s) => s.idenOgan == Number(value)
    )[0].departments;
    this.setoresPorOrg.set([...setores]);
    if (setores.length === 1) {
      this.selecaoForm.controls.setor.setValue(setores[0]);
      const setorName = setores[0].nomeSetr;
      localStorage.setItem("setor-name", setorName);
    }
  };

    saveSetor() {     
      const organizacaoName = this.organizacoes().filter(
        (o) =>
          o.idenOgan ===
          Number(this.selecaoForm.value.organizacao)
      )[0].nomeOgan;
      localStorage.setItem('organizacao-name', organizacaoName);
      const setorNamet = this.setoresPorOrg()?.filter(
        (s) =>
          s.codiSetr ==
          Number(this.selecaoForm.value.setor)
      );
      const setorName = this.setoresPorOrg()?.filter(
        (s) =>
          s.codiSetr ==
          Number(this.selecaoForm.value.setor)
      )[0].nomeSetr;
      localStorage.setItem('setor-name', setorName);

      this.cookieService.put(
        environment.oab_organizacao_padrao,
         this.selecaoForm.value.organizacao,
        { domain: ".oab.org.br" }
      );

      this.cookieService.put(
        environment.oab_setor_padrao,
          this.selecaoForm.value.setor,
        { domain: ".oab.org.br" }
      );
      setTimeout(() => {  this.handleModal.emit(false); window.location.reload(); }, 1000);
      
    }
}
